// src/router.js
import {createRouter, createWebHistory} from 'vue-router';
import AppHome from './views/AppHome.vue';
import HistoryView from './views/HistoryView.vue';

const routes = [
    {
        path: '/',
        name: 'Home',
        component: AppHome,
        // Chỉ chuyển các query params cần thiết thành props
        props: route => ({
            searchTerm: route.query.search,
            genre: route.query.genre
        })
    },
    {
        path: '/history',
        name: 'History',
        component: HistoryView,
    },
    // XÓA BỎ ROUTE '/story/:slug'
];

const router = createRouter({
    history: createWebHistory(),
    routes,
});

export default router;
